import FormValidator from "./FormValidator";

export const getValidationPercent = (form, rules) => {
    const [warning, progress] = FormValidator(form, rules);
    return progress;
}

